import Dropdown from '@vtex/styleguide/lib/Dropdown';

export function VtexDropdown({ ...otherProps }) {
	return <Dropdown {...otherProps} />;
}
